import { RootState } from '@/store';

import { formatDateWithAge } from '@/pages/physician/TransmissionReportPage/ReportPatientDetails/utils';
import { Patient } from '@/types/patient';

export const selectPatientDataById = (state: RootState, patientId: string) => {
  return state.patientsApi.queries[`getPatient("${patientId}")`]?.data as Patient | undefined;
};

const formatPhone = (phone: string | undefined | null) => {
  if (!phone) return undefined;
  return phone;
};

export const selectPatientOverviewDetails = (state: RootState, patientId: string) => {
  const patient = selectPatientDataById(state, patientId);

  if (!patient) return null;

  return {
    id: patient.id,
    firstName: patient.givenName || undefined,
    lastName: patient.familyName || undefined,
    preferredName: patient.preferredName || undefined,
    dateOfBirth: formatDateWithAge(patient.birthDate),
    address1: patient.address?.line1 || undefined,
    address2: patient.address?.line2 || undefined,
    city: patient.address?.city || undefined,
    state: patient.address?.state || undefined,
    zip: patient.address?.postalCode || undefined,
    phoneNumber: formatPhone(patient.phoneNumber),
    homePhone: formatPhone(patient.homePhone),
    otherPhone: formatPhone(patient.otherPhone),
    sex: patient.sex || undefined,
    mrn2: patient.mrn2 || undefined,
    birthDate: patient.birthDate || undefined,
    addressId: patient.address?.id || undefined
  };
};
